import { DoubleSide, MeshPhysicalMaterial } from "three";

export const DNAMaterial = async (color: number) => {
	return new MeshPhysicalMaterial({
		color: color, // Türkis
		roughness: 0.1, // Glanz: je kleiner der Wert, desto glänzender
		metalness: 0.1, // Geringe metallische Reflexionen
		transparent: true, // Transparenz aktivieren
		opacity: 0.6, // Leicht durchscheinend
		clearcoat: 0.5, // Zusätzlicher Glanz (wie Klarlack)
		clearcoatRoughness: 0.2, // Glanz-Rauhigkeit reduzieren
		transmission: 0.6, // Simuliert Lichtdurchgang (Transluzenz)
		side: DoubleSide, // Beide Seiten sichtbar machen
		ior: 2,
		thickness: 2,
		iridescence: 1,
		iridescenceIOR: 0.92, //sehr heller sheen .97
		sheen: 1,
		sheenRoughness: 0.1,
	});
};
